// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import Barcode from '@tcp/core/src/components/common/molecules/Barcode';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import ContentLink from '@tcp/core/src/components/features/account/common/molecule/ContentLink';
import ModuleX from '@tcp/core/src/components/common/molecules/ModuleX';
import { BodyCopy } from '../../../../../../../../styles/themes/TCP/typotheme';
import styles from '../styles/CouponDetailModal.style';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import CouponLabels, { ACCOUNT_COMMON, ACCOUNT_OVERVIEW, CHECKOUT_LABELS } from './Coupon.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblTnc,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const COUPON_APPLIED = 'applied';
const PLACE_PERKS_IMPLICIT = 'PERKS-IMPLICIT';
const PLACE_CASH_COUPON = 'PLACECASH';

class CouponDetailModal extends React.PureComponent {
  static defaultProps = {
    isConfirmation: false,
  };

  componentDidUpdate() {
    const { coupon, handleErrorCoupon } = this.props;
    if (coupon?.error && handleErrorCoupon) {
      handleErrorCoupon(coupon);
    }
  }

  printClick = (event) => {
    window.print();
    event.preventDefault();
  };

  /**
   * This function is used for apply to bag coupon
   * can be passed in the component.
   */
  handleApplyToBag = () => {
    const { onApplyCouponToBagFromList, coupon, onRequestClose } = this.props;
    setTimeout(() => {
      onApplyCouponToBagFromList({ coupon });
      onRequestClose();
    }, 0);
  };

  renderModal = () => {
    const { coupon, className, isConfirmation, multiUseCouponList } = this.props;
    const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, CouponLabels);
    const accountOverviewLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_OVERVIEW, CouponLabels);
    const accountCommonLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_COMMON, CouponLabels);

    const { isStarted } = coupon;
    const isApplied = coupon.status === COUPON_APPLIED;
    const isPlacePerks =
      coupon.originalOfferType === PLACE_PERKS_IMPLICIT || coupon?.fromBonusPointsDay;
    const couponId =
      coupon && coupon.id && coupon.id.indexOf('-') > -1 ? coupon.id.split('-')[1] : coupon.id;
    const isPlaceCash = coupon?.redemptionType === PLACE_CASH_COUPON;
    const couponList = multiUseCouponList?.split('|');
    const couponFound = couponList?.find((couponItem) => couponItem === coupon?.id);
    return (
      <div className={className}>
        <BodyCopy
          fontWeight="black"
          className="couponModal_modalTitle text-break"
          data-locator={`couponDetailModal_${coupon.status}_NameLbl`}
        >
          {coupon.title}
        </BodyCopy>
        {!isConfirmation && (
          <BodyCopy
            fontWeight="bold"
            fontFamily="secondaryFontFamily"
            className="couponModal_modalSubTitle"
            data-locator={`couponDetailModal_${coupon.status}_ValidityDateLbl`}
          >
            {!isPlaceCash
              ? `${renderLabel(
                  checkoutLabels?.bagPage?.lbl_coupon_validThru,
                  'lbl_coupon_validThru'
                )} ${coupon?.expirationDate}`
              : `${renderLabel(
                  accountOverviewLabels?.lbl_overview_couponValid,
                  'lbl_overview_couponValid'
                )} ${coupon?.effectiveDate} - ${coupon?.expirationDate}`}
          </BodyCopy>
        )}
        {couponId && !isPlacePerks && !couponFound && (
          <BodyCopy
            component="div"
            data-locator={`couponDetailModal_${coupon.status}_BarCode`}
            className="couponModal_modalbarcode"
            aria-label={coupon.id}
            role="img"
          >
            <BodyCopy component="div" className="elem-mt-MED elem-mb-MED" aria-hidden>
              <Barcode value={couponId} barcodeId={couponId} fontSize={24} />
            </BodyCopy>
          </BodyCopy>
        )}
        {!isConfirmation && isStarted && !isPlacePerks && coupon.isOnHold !== 'true' && (
          <div className="couponModal_btnWrapper">
            <Button
              buttonVariation="fixed-width"
              fill="BLUE"
              onClick={this.handleApplyToBag}
              disabled={isApplied}
              className="couponModal_applyToBag couponModal_btn"
              data-locator={`couponDetailModal_${coupon.status}_AddToBagBtn`}
            >
              {isApplied
                ? renderLabel(
                    accountCommonLabels?.lbl_common_applied_to_bag,
                    'lbl_common_applied_to_bag'
                  )
                : renderLabel(
                    checkoutLabels?.bagPage?.lbl_couponlist_applyTobag,
                    'lbl_common_applied_to_bag'
                  )}
            </Button>
          </div>
        )}
        {!isPlacePerks && (
          <div className="couponModal_print">
            <Anchor
              underline
              anchorVariation="primary"
              fontSize="fs14"
              dataLocator={`couponDetailModal_${coupon.status}_printAch`}
              to="/#"
              onClick={this.printClick}
            >
              {renderLabel(
                checkoutLabels?.bagPage?.lbl_couponlist_printTxt,
                'lbl_couponlist_printTxt'
              )}
            </Anchor>
          </div>
        )}
        <BodyCopy
          fontFamily="secondaryFontFamily"
          className="couponModal_modalLongDesc"
          data-locator={`couponDetailModal_${coupon.status}_LongDesc`}
        >
          <ModuleX
            className="coupon-details-content"
            data-locator="coupon-details-info-model-content"
            richTextList={[{ text: coupon.legalText }]}
          />
        </BodyCopy>
        {!isConfirmation && (
          <BodyCopy
            fontFamily="secondaryFontFamily"
            className="couponModal_modalShortDesc"
            data-locator={`couponDetailModal_${coupon.status}_ShortDesc`}
          >
            {`${renderLabel(
              getDynamicLabelValues('dynamic.cart.lbl_couponlist_modalShortDesc'),
              'lbl_couponlist_modalShortDesc'
            )}`}
            <ContentLink
              underline
              anchorVariation="primary"
              fontSize="fs14"
              dataLocator={`couponDetailModal_${coupon.status}_tAndC`}
              urlKey="lbl_termcondition_link"
              className="couponModal_print_anchortext"
              target="_blank"
            >
              {renderLabel(
                getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_GENERIC_LABELS}.${lblTnc}`,
                  GlobalGenericLabels
                ),
                'lbl_tnc'
              )}
            </ContentLink>

            {` and `}
            <ContentLink
              underline
              anchorVariation="primary"
              fontSize="fs14"
              dataLocator={`couponDetailModal_${coupon.status}_pp`}
              urlKey="lbl_privacyPolicy_link"
              className="couponModal_print_anchortext"
              target="_blank"
            >
              {`${renderLabel(
                checkoutLabels?.bagPage?.lbl_couponlist_pPolicy,
                'lbl_couponlist_pPolicy'
              )}`}
            </ContentLink>
          </BodyCopy>
        )}
      </div>
    );
  };

  render() {
    const { openState, coupon, onRequestClose, additionalClassNameModal } = this.props;
    return (
      openState && (
        <Modal
          isOpen={openState}
          onRequestClose={onRequestClose}
          overlayClassName="TCPModal__Overlay"
          className="TCPModal__Content"
          heightConfig={{ height: '90%' }}
          contentLabel={coupon.title}
          closeIconDataLocator="coupondetailmodalcrossicon"
          customWrapperClassName={additionalClassNameModal}
        >
          {this.renderModal()}
        </Modal>
      )
    );
  }
}

CouponDetailModal.propTypes = {
  coupon: PropTypes.shape({}).isRequired,
  handleErrorCoupon: PropTypes.func.isRequired,
  onApplyCouponToBagFromList: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  openState: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  additionalClassNameModal: PropTypes.string.isRequired,
  isConfirmation: PropTypes.bool,
};

export default withStyles(CouponDetailModal, styles);
export { CouponDetailModal as CouponDetailModalVanilla };
